
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import {
  Banner,
  TextLink,
  LinkUnderlined,
  Category,
  Size,
  Margin,
  Button,
  Icon,
} from '@drawbotics/react-drylus';
import Playground from '~/components/Playground';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Banner`}</h1>
<p>{`Component used to display an important message that should take precedence over the rest of the content of the page. Similar to `}<a parentName="p" {...{
        "href": "/component-kit/components/callout"
      }}><inlineCode parentName="a">{`Callout`}</inlineCode></a>{`, but used to the inform the user of possible actions he needs to make, or as a result of an `}<em parentName="p">{`uncontrolled`}</em>{` effect. Cannot be dismissed.`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Banner } from '@drawbotics/react-drylus';
`}</code></pre>
<p><strong parentName="p">{`Example`}</strong></p>
<Playground __position={0} __code={`<Banner title="You don't have enough credits" category={Category.DANGER}>
  Your order will not go into production because your credit number is below 0. Click <TextLink underlined={LinkUnderlined.ALWAYS}>here</TextLink> to buy more credits.
  <Margin size={{ top: Size.SMALL }}>
    If you don't buy more in 10 days your order will be void.
  </Margin>
</Banner>`} component={Banner} mdxType="Playground">
  <Banner title="You don't have enough credits" category={Category.DANGER} mdxType="Banner">
    Your order will not go into production because your credit number is below 0. Click <TextLink underlined={LinkUnderlined.ALWAYS} mdxType="TextLink">here</TextLink> to buy more credits.
    <Margin size={{
          top: Size.SMALL
        }} mdxType="Margin">
      If you don't buy more in 10 days your order will be void.
    </Margin>
  </Banner>
</Playground>
<p>{`For small information snippets you can leave it without title to be more concise and use less space.`}</p>
<Playground __position={1} __code={`<>
  <Margin size={{ bottom: Size.DEFAULT }}>
    <Banner category={Category.INFO}>
      A new service is now available.
    </Banner>
  </Margin>
  <Margin size={{ bottom: Size.DEFAULT }}>
    <Banner category={Category.WARNING}>
      You used all your correction rounds.
    </Banner>
  </Margin>
  <Margin size={{ bottom: Size.DEFAULT }}>
    <Banner category={Category.DANGER}>
      Your floorplans will not go into production, we need them to get started.
    </Banner>
  </Margin>
  <Banner category={Category.SUCCESS}>
    Congratulation, you can now send your items to production.
  </Banner>
</>`} mdxType="Playground">
  <>
    <Margin size={{
          bottom: Size.DEFAULT
        }} mdxType="Margin">
      <Banner category={Category.INFO} mdxType="Banner">
        A new service is now available.
      </Banner>
    </Margin>
    <Margin size={{
          bottom: Size.DEFAULT
        }} mdxType="Margin">
      <Banner category={Category.WARNING} mdxType="Banner">
        You used all your correction rounds.
      </Banner>
    </Margin>
    <Margin size={{
          bottom: Size.DEFAULT
        }} mdxType="Margin">
      <Banner category={Category.DANGER} mdxType="Banner">
        Your floorplans will not go into production, we need them to get started.
      </Banner>
    </Margin>
    <Banner category={Category.SUCCESS} mdxType="Banner">
      Congratulation, you can now send your items to production.
    </Banner>
  </>
</Playground>
<p>{`Banners can also be given a CTA by passing a trailing component, which should always be a `}<inlineCode parentName="p">{`Button`}</inlineCode>{`. CTAs are `}<em parentName="p">{`especially`}</em>{` useful in `}<inlineCode parentName="p">{`DANGER`}</inlineCode>{` category banners, as they provide the user with a possible solution. Here is an example:`}</p>
<Playground __position={2} __code={`<Banner
  category={Category.DANGER}
  trailing={<Button trailing={<Icon name="alert-triangle" />}>Buy credits</Button>}>
  Your floorplans will not go into production, we need them to get started.
</Banner>`} mdxType="Playground">
  <Banner category={Category.DANGER} trailing={<Button trailing={<Icon name="alert-triangle" mdxType="Icon" />} mdxType="Button">Buy credits</Button>} mdxType="Banner">
    Your floorplans will not go into production, we need them to get started.
  </Banner>
</Playground>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;